import { Extensions } from './Extensions'

export class SortingExtensions extends Extensions {}
